export namespace aiaPersonnel {
  export async function getAllPersonnel(token: string, host: any) {
    console.log('host is:' + host);
    return await fetch(host + "/api/personnel/AIA/Get?token=" + token);
  }
}
